class S12n {
  constructor(props: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    this.s12n = props.s12n;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ownership' does not exist on type 'S12n'... Remove this comment to see the full error message
    this.ownership = props.ownership;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'membership' does not exist on type 'S12n... Remove this comment to see the full error message
    this.membership = props.s12n.get('membership');
  }

  /**
   * @returns {Backbone S12n} The Backbone s12n model. Only use this for compatibility with legacy components.
   */
  getBackboneModel() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n;
  }

  getOwnership() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ownership' does not exist on type 'S12n'... Remove this comment to see the full error message
    return this.ownership;
  }

  getId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('id');
  }

  getName() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('name');
  }

  getLink() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.getLink();
  }

  getDescription() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('description');
  }

  getLogo() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('logo');
  }

  getCourse(courseId: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('courses').get(courseId);
  }

  getCourseNumber(courseId: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('courseIds').indexOf(courseId) + 1;
  }

  getNumCourses() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('courseIds').length;
  }

  getNextCourseId(courseId: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    const courseIds = this.s12n.get('courseIds');
    const index = courseIds.indexOf(courseId);
    if (index + 1 < courseIds.length) {
      return courseIds[index + 1];
    }
  }

  getNextCourse(courseId: $TSFixMe) {
    const nextCourseId = this.getNextCourseId(courseId);
    if (nextCourseId) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
      return this.s12n.get('courses').get(nextCourseId);
    }
  }

  /**
   * @returns {Course} - The first course after `startAtCourseId` in the s12n that is incomplete
   * and that the user is allowed to take. If `startAtCourseId` is undefined or if it refers to
   * a course that is not in the capstone, then we start looking at the first course.
   *
   * Examples:
   *
   * If there are 4 non-capstone courses in the s12n and the user has only completed #3, then
   *   getNextIncompleteCourse(course1id) = course2
   *   getNextIncompleteCourse(course3id) = course4
   *
   * If the first 4 courses in the s12n, the first 3 are not capstones, the last is a capstone,
   * and the user has only completed #3, then
   *   getNextIncompleteCourse(course3id) = course1
   * because the user is not allowed to take course4 (the capstone) until they have completed all the courses.
   */
  getNextIncompleteCourse(startAtCourseId: $TSFixMe) {
    let membership;

    if (this.isEligibleForCapstone()) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
      const capstone = this.s12n.getCapstone();
      if (!capstone) return null;
      membership = capstone.get('memberships').last();

      // Assuming the learner is eligible for a capstone, if they have finished the capstone
      // there are no incomplete courses, otherwise the capstone is the only incomplete course left.
      return membership && membership.hasPassed() ? null : capstone;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    const courses = this.s12n.get('courses');
    const currentCourseIdx = courses.indexOf(courses.get(startAtCourseId));

    // Cycle the list of courses so that the course at `currentCourseIdx + 1` is the first course.
    // The behavior at these edge cases is intentional:
    //   `currentCourseIdx == -1` -> Use the uncycled list of courses.
    //   `currentCourseIdx == courses.size() - 1` -> Use the uncycled list of courses.
    const cycledCourses = [].concat(courses.slice(currentCourseIdx + 1), courses.slice(0, currentCourseIdx + 1));

    const nextIncompleteCourse = cycledCourses.find((course) => {
      // skip capstone as learner is not eligible
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isCapstone' does not exist on type 'neve... Remove this comment to see the full error message
      if (!course.isCapstone()) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'get' does not exist on type 'never'.
        membership = course.get('memberships').last();

        // Return course if the learner is not enrolled / has not passed
        if (!(membership && membership.hasPassed())) {
          return true;
        }
      }
      return false;
    });

    return nextIncompleteCourse || null;
  }

  /**
   * @returns {string} - A status string that is passed into the course settings view to display
   * the appropriate specialization status badge for the current course.
   */
  getEnrollmentStatus(isEnrolledInCourse: $TSFixMe) {
    return this.isTakingS12n() ? 'registered' : isEnrolledInCourse ? 'free-enrolled' : 'browsing';
  }

  isTakingS12n() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'membership' does not exist on type 'S12n... Remove this comment to see the full error message
    return this.membership && this.membership.isEnrolled();
  }

  hasBulkPaid() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ownership' does not exist on type 'S12n'... Remove this comment to see the full error message
    return this.ownership && this.ownership.hasBulkPaid();
  }

  ownsCourse(courseId: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ownership' does not exist on type 'S12n'... Remove this comment to see the full error message
    return this.ownership && this.ownership.ownsCourse(courseId);
  }

  isCapstone(courseId: $TSFixMe) {
    // Get the catalogP version of the course model, which has capstone information.
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    const course = this.s12n.get('courses').get(courseId);
    if (course) {
      return course.isCapstone();
    }
    return false;
  }

  isEligibleForCapstone() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.isEligibleForCapstone();
  }

  getCapstone() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('courses').find((course) => course.isCapstone());
  }

  ownsCapstone(courseId: $TSFixMe) {
    const capstone = this.getCapstone();
    return this.ownsCourse(capstone.get('id'));
  }

  getCertificateLogos() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.getCertificateLogos();
  }

  getHeaderImage() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.get('metadata').headerImage;
  }

  getNumberOfCourses() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n.getNumCourses();
  }

  getNumberOfCoursesCompleted() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 's12n' does not exist on type 'S12n'.
    return this.s12n
      .get('courses')
      .chain()
      .filter((course: $TSFixMe) => {
        const membership = course.get('memberships').last();
        return membership && membership.hasPassed();
      })
      .size()
      .value();
  }
}

export default S12n;
